<template>
  <div
    v-if="sectors.length > 0"
    class="mobile-width-height relative flex items-center px-2 py-2 md:py-0"
  >
    <div class="mobile-width-height absolute left-0 top-0">
      <vue3-chart-js
        :id="doughnutChart.id"
        ref="chartRef"
        :type="doughnutChart.type"
        :data="doughnutChart.data"
        :options="doughnutChart.options"
      >
      </vue3-chart-js>
    </div>
    <div class="text-dougnhut w-full px-8">
      <p class="text-xs font-normal text-grey-3">
        {{ globalSectors.graphicTotal }}
      </p>
      <p class="text-xs font-bold text-grey-2">
        ${{ dollarFormatting(sectors.reduce((a, b) => parseFloat(a) + parseFloat(b.value), 0)) }}
      </p>
    </div>
  </div>
</template>

<script>
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'
import { ref, watch } from 'vue'
import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'

export default {
  name: 'App',
  components: {
    Vue3ChartJs,
  },
  props: {
    sectors: {
      type: Array,
      default: () => [],
    },
    globalSectors: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { dollarFormatting } = useGlobalHelpers()
    const chartRef = ref(true)
    const doughnutChart = ref({
      id: 'doughnut',
      type: 'doughnut',
      data: {
        labels: props.sectors.map((a) => a.label),
        datasets: [
          {
            backgroundColor: props.sectors.map((a) => a.color),
            borderWidth: 0,
            data: props.sectors.map((a) => parseInt(a.value)),
            borderColor: props.sectors.map((a) => a.color),
            hoverBorderWidth: 5,
          },
        ],
      },
      options: {
        cutout: '70%',
        intersect: true,
        layout: {
          padding: 20,
        },
        interaction: {
          mode: 'index',
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
            external: function (context) {
              const tooltipElBall = document.getElementById(
                'highlight-ball-' + context.tooltip.dataPoints[0].dataIndex
              )
              const tooltipEl = document.getElementById(
                'highlight-text-' + context.tooltip.dataPoints[0].dataIndex
              )

              if (!tooltipEl || !tooltipElBall) {
                tooltipEl.classList.remove('font-bold')
                tooltipElBall.classList.remove(
                  'border',
                  'border-double',
                  'border-gray-600',
                  'animate-bounce'
                )
                return
              }

              const tooltipModel = context.tooltip
              if (tooltipModel.opacity === 0) {
                tooltipEl.classList.remove('font-bold')
                tooltipElBall.classList.remove(
                  'border',
                  'border-double',
                  'border-gray-600',
                  'animate-bounce'
                )
                return
              }

              // Failsafe if people hover too fast to remove classes from other labels that are no the active one
              document.querySelectorAll('.graph-hover').forEach(function (node) {
                if (
                  node.id !== 'highlight-text-' + tooltipModel.dataPoints[0].dataIndex ||
                  node.id !== 'highlight-ball-' + tooltipModel.dataPoints[0].dataIndex
                ) {
                  node.classList.remove(
                    'font-bold',
                    'border',
                    'border-double',
                    'border-gray-600',
                    'animate-bounce'
                  )
                }
              })

              tooltipEl.classList.add('font-bold')
              tooltipElBall.classList.add(
                'border',
                'border-double',
                'border-gray-600',
                'animate-bounce'
              )
            },
          },
        },
      },
    })

    watch(
      () => props.sectors,
      (newValue) => {
        if (newValue.length > 0) {
          doughnutChart.value.data.labels = newValue.map((a) => a.label)
          doughnutChart.value.data.datasets = [
            {
              backgroundColor: newValue.map((a) => a.color),
              data: newValue.map((a) => parseInt(a.value)),
            },
          ]
          chartRef.value.update(250)
        }
      }
    )

    return {
      doughnutChart,
      chartRef,
      dollarFormatting,
    }
  },
}
</script>

<style lang="postcss" scoped>
.mobile-width-height {
  height: 200px;
  width: 200px;
}

@media only screen and (max-width: 800px) {
  .text-dougnhut {
    padding: 30%;
  }
}
</style>
